<template>
  <span
    class="inline-flex items-center rounded-full leading-6 bg-primary-50 dark:bg-primary-900 font-medium dark:text-white ring-1 ring-inset ring-primary-500/20"
    :class="style[size]"
    v-text="title"
  />
</template>
<script setup>
defineProps({
  title: {
    type: String,
    default: '',
  },
  size: {
    type: String,
    default: 'xs',
  },
})

const style = {
  xs: 'text-xs px-1.5 py-0.5',
  sm: 'text-sm px-1.5 py-0.5',
  base: 'text-sm px-3 py-1',
  lg: 'text-base md:text-lg px-4 py-1',
}
</script>
